import { ResourceCategory } from '../../models/Resources';

export const category1234SubCategories: ResourceCategory[] = [
  {
    id: 5678,
    title: 'E-Verify Participation Poster',
    description: 'E-Verify Participation Poster',
    displaySequence: 1,
    documents: [
      {
        title: 'E-Verify Participation Poster - English and Spanish',
        type: 'pdf',
        link: '/documents/1234/content',
        displaySequence: 1,
      },
      {
        title: 'E-Verify Participation Poster - English',
        type: 'pdf',
        link: '/documents/1235/content',
        displaySequence: 2,
      },
      {
        title: 'E-Verify Participation Poster - Spanish',
        type: 'pdf',
        link: '/documents/1236/content',
        displaySequence: 3,
      },
    ],
    subCategories: null,
  },
  {
    id: 5679,
    title: 'Right to Work Poster',
    description: 'Right to Work Poster',
    displaySequence: 2,
    documents: [
      {
        title: 'Right to Work Poster - English',
        type: 'external',
        link: 'https://www.justice.gov/crt/case-document/file/1133936/download',
        displaySequence: 1,
      },
      {
        title: 'Right to Work Poster - Spanish',
        type: 'external',
        link: 'https://www.justice.gov/crt/case-document/file/1133941/download',
        displaySequence: 2,
      },
    ],
    subCategories: null,
  },
];

export const category6789SubCategories: ResourceCategory[] = [
  {
    id: 3890,
    title: 'Referral Date Confirmation',
    description:
      'The sample Referral Date Confirmations are provided as a reference to users of E-Verify. The Referral Date Confirmation is provided to the employee after the employer refers a case to SSA or DHS to resolve a TNC and provides the date by which the employee must follow up with SSA or DHS. The employee should refer to the Further Action Notice for specific instructions on how to contest a TNC.',
    displaySequence: 1,
    documents: [],
    subCategories: '/categories/3890/subcategories',
  },
];

export const category3890SubCategories: ResourceCategory[] = [
  {
    id: 2342,
    title: 'DHS',
    description: null,
    displaySequence: 1,
    documents: [
      {
        title: 'Referral Date Confirmation - English',
        type: 'pdf',
        link: '/documents/1234/content',
        displaySequence: 1,
      },
    ],
    subCategories: '/categories/2342/subcategories',
  },
  {
    id: 2343,
    title: 'SSA',
    description: null,
    displaySequence: 2,
    documents: [
      {
        title: 'Referral Date Confirmation - English',
        type: 'pdf',
        link: '/documents/1234/content',
        displaySequence: 1,
      },
    ],
    subCategories: '/categories/2343/subcategories',
  },
];

export const category2342SubCategories: ResourceCategory[] = [
  {
    id: 2344,
    title: 'Other Languages',
    description: null,
    displaySequence: 1,
    documents: [
      {
        title: 'Referral Date Confirmation - Spanish',
        type: 'pdf',
        link: '/documents/1234/content',
        displaySequence: 1,
      },
    ],
    subCategories: null,
  },
];

export const category2343SubCategories: ResourceCategory[] = [
  {
    id: 2666,
    title: 'Other Languages',
    description: null,
    displaySequence: 1,
    documents: [
      {
        title: 'Referral Date Confirmation - Spanish',
        type: 'pdf',
        link: '/documents/1234/content',
        displaySequence: 1,
      },
    ],
    subCategories: null,
  },
];
